import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { DisruptionNotificationsNdcTechnicalFaqPage } from 'src/app/model/page/group/faq/disruption-notifications-ndc-technical-faq';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-disruption-notifications-ndc-technical-faq-page',
  templateUrl: './disruption-notifications-ndc-technical-faq-page.component.html',
  styleUrls: ['./disruption-notifications-ndc-technical-faq-page.component.scss']
})
export class DisruptionNotificationsNdcTechnicalFaqPageComponent implements OnInit {
  param: number = -1;
  disruptionNotificationsNdcTechnicalFaqPage: DisruptionNotificationsNdcTechnicalFaqPage = {} as DisruptionNotificationsNdcTechnicalFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-technical-disruption') {
        this.disruptionNotificationsNdcTechnicalFaqPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));
    this.disruptionNotificationsNdcTechnicalFaqPage.sections = [];

    const query = { 'fields.title': 'NDC Technical FAQ#Disruption Notifications' };
    this.contentfulService.getPageContentWithEntries(query).then((disruptionNotificationsNdcTechnicalFaqPageEntries) => {
      this.mapBanner(disruptionNotificationsNdcTechnicalFaqPageEntries);
      this.mapSections(disruptionNotificationsNdcTechnicalFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.disruptionNotificationsNdcTechnicalFaqPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }

  private mapBanner(disruptionNotificationsNdcTechnicalFaqPageEntries: Entry<any>[]) {
    disruptionNotificationsNdcTechnicalFaqPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.disruptionNotificationsNdcTechnicalFaqPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(disruptionNotificationsNdcTechnicalFaqPageEntries: Entry<any>[]) {
    disruptionNotificationsNdcTechnicalFaqPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.disruptionNotificationsNdcTechnicalFaqPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    // console.log(entry);

    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[2];

    this.disruptionNotificationsNdcTechnicalFaqPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
